import { createSlice } from "@reduxjs/toolkit";

// ============ INTERFACE ============

export interface ModalStateInterface {
  callMeModal: {
    open: boolean;
  },
  termsAndConditionsModal: {
    open: boolean;
  },
  contactModal: {
    open: boolean;
  },
}

// ============ INIT STATE ============

const initialState: ModalStateInterface = {
  callMeModal: {
    open: false,
  },
  termsAndConditionsModal: {
    open: false,
  },
  contactModal: {
    open: false,
  },
};

// ========= SLICE ==========

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openCallMeModal: (state: ModalStateInterface) => {
      state.callMeModal.open = true;
    },
    closeCallMeModal: (state: ModalStateInterface) => {
      state.callMeModal.open = false;
    },
    openTermsAndConditionsModal: (state: ModalStateInterface) => {
      state.termsAndConditionsModal.open = true;
    },
    closeTermsAndConditionsModal: (state: ModalStateInterface) => {
      state.termsAndConditionsModal.open = false;
    },
    openContactModal: (state: ModalStateInterface) => {
      state.contactModal.open = true;
    },
    closeContactModal: (state: ModalStateInterface) => {
      state.contactModal.open = false;
    },
  }
})

export const { openCallMeModal, closeCallMeModal, openTermsAndConditionsModal, closeTermsAndConditionsModal, openContactModal, closeContactModal, } = modalSlice.actions;

export default modalSlice.reducer;